import { render, staticRenderFns } from "./prefixIcon-editor.vue?vue&type=template&id=3918c142&scoped=true"
import script from "./prefixIcon-editor.vue?vue&type=script&lang=js"
export * from "./prefixIcon-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918c142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3918c142')) {
      api.createRecord('3918c142', component.options)
    } else {
      api.reload('3918c142', component.options)
    }
    module.hot.accept("./prefixIcon-editor.vue?vue&type=template&id=3918c142&scoped=true", function () {
      api.rerender('3918c142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/prefixIcon-editor.vue"
export default component.exports